import React from "react";
import styled from "styled-components";
import { RefreshCcw } from "lucide-react"; // Lucide icon import

const LoaderSec = styled.div`
  > svg {
    animation: rotateLoader 1s infinite linear;
  }

  @keyframes rotateLoader {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const ButtonLoader = () => {
  return (
    <LoaderSec>
      <RefreshCcw size={16} strokeWidth={2} />
    </LoaderSec>
  );
};

export default ButtonLoader;
